import { render, staticRenderFns } from "./Analises.vue?vue&type=template&id=6915518d&scoped=true"
import script from "./Analises.vue?vue&type=script&lang=js"
export * from "./Analises.vue?vue&type=script&lang=js"
import style0 from "./Analises.vue?vue&type=style&index=0&id=6915518d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6915518d",
  null
  
)

export default component.exports